import yousersjs from '@yola/yousersjs';

const resetPassword = (data) => yousersjs.requests.resetPassword(data);

export default resetPassword;
